import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["caret", "children", "className"];

/**
 * Copyright IBM Corp. 2021, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { Button } from 'carbon-components-react';
import cx from 'classnames';
import { bool, node, string } from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { pkg } from '../../settings';
import { blockClass as toolbarClass, ToolbarContext } from './Toolbar';
var blockClass = "".concat(toolbarClass, "__button");
/** Toolbar buttons are common functions performed as part of a products interface or an open window.  */

var ToolbarButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _useContext;

  var caret = _ref.caret,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({
    tooltipPosition: ((_useContext = useContext(ToolbarContext)) === null || _useContext === void 0 ? void 0 : _useContext.vertical) && 'right'
  }, rest, {
    ref: ref,
    className: cx(className, _defineProperty({}, "".concat(blockClass, "--caret"), caret)),
    kind: "ghost",
    size: "md",
    hasIconOnly: true
  }), /*#__PURE__*/React.createElement(React.Fragment, null, children, caret && /*#__PURE__*/React.createElement("span", {
    className: "".concat(blockClass, "__caret")
  })));
});
var componentName = 'ToolbarButton';
ToolbarButton.displayName = componentName;
ToolbarButton.propTypes = {
  /** Determines whether the caret is rendered */
  caret: bool,

  /** Provide the content of the `ToolbarButton` */
  children: node,

  /** Provide an optional class to be applied to the containing node */
  className: string
};
ToolbarButton = pkg.checkComponentEnabled(ToolbarButton, componentName);
export { blockClass, ToolbarButton };